var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "licence-analytic",
      class: [_vm.editMode ? "editMode" : ""],
    },
    [
      _c("input", {
        class: [_vm.editMode ? "edit-mode" : "read-only"],
        attrs: {
          id: _vm.uniq,
          maxlength: "30",
          type: "text",
          readonly: _vm.editMode === false,
        },
        domProps: { value: _vm.object.analyticCode },
        on: {
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.editMode && _vm.edit(true)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.editMode && _vm.edit(false)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa fa-fw fa-2x",
        class: [_vm.editMode ? "fa-check" : "fa-pencil-square"],
        on: {
          click: function ($event) {
            return _vm.edit(true)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }